import { createTheme } from '@mui/material'
import componentsOverride from '@totalsoft/rocket-ui/dist/components/themes/common/overrides'
import generatePalette from '@totalsoft/rocket-ui/dist/components/themes/common/palette'
import { generateTypography } from '@totalsoft/rocket-ui/dist/components/themes/common/typography'
import { generateShadows, generateCustomShadows } from '@totalsoft/rocket-ui/dist/components/themes/common/shadows'
import table from '@totalsoft/rocket-ui/dist/components/themes/common/table'

const palette = generatePalette({
  primary: {
    lighter: '#f5f5f5',
    light: '#eeeeee',
    main: '#e0e0e0',
    dark: '#bdbdbd',
    darker: '#9e9e9e',
    contrastText: '#000',
    rgba: 'rgba(224, 224, 224, 1)'
  },
  secondary: {
    lighter: '#ffffff',
    light: '#f5f5f5',
    main: '#eeeeee',
    dark: '#e0e0e0',
    darker: '#bdbdbd',
    contrastText: '#000',
    rgba: 'rgba(238, 238, 238, 1)'
  },
  background: {
    default: '#ffffff',
    paper: '#ffffff'
  },
  sideMenu: {
    bgColor: '#ffffffd9',
    color: '#000',
    hoverBgColor: 'rgba(0, 0, 0, 0.1)',
    hoverTextColor: '#000',
    bgOpacity: '0.8',
    activeBgColor: '#e0e0e0'
  }
})

const whiteTheme = createTheme({
  palette,
  shape: { borderRadius: 8 },
  typography: generateTypography(palette),
  table,
  shadows: generateShadows(palette),
  customShadows: generateCustomShadows(palette)
})

whiteTheme.components = componentsOverride(whiteTheme)

export default whiteTheme
